import { Tabs, Theme, TabDesign, TabLayout, NextgenImage, GenericLink, LoaderType } from '@nextgen-web-framework/all';
import { FC, useState, useEffect } from 'react';
import type { NewsTimelinesProps } from './types/propsTypes';
import styles from './NewsTimelines.module.scss';

const { PURPLE } = Theme;
const { HORIZONTAL } = TabLayout;
const { TRANSPARENT } = TabDesign;

const NewsTimelines: FC<NewsTimelinesProps> = (props) => {
  const { year } = props;
  const currentIndex = props.tabsData.findIndex((index) => index.id == year.toString());
  const [index, setIndex] = useState(currentIndex);

  useEffect(() => {
    setIndex(currentIndex);
  }, [currentIndex]);

  return (
    <>
      <div data-testid={'newstimelines-tabs-test-id'}>
        <h2 className={styles['news-heading']}>{props.heading}</h2>
        <div className={styles['news-timelines-tabs-scroller']}>
          <Tabs
            theme={PURPLE}
            layout={HORIZONTAL}
            selectedTab={index}
            onTabClick={(index, yearData) => {
              props.callBack?.(yearData);
              setIndex(index);
            }}
            design={TRANSPARENT}
            tabList={props.tabsData}
          />
        </div>
        <div className={styles['news-timelines-container']}>
          {props.currentYearData.map((newsData) => (
            <div
              key={`${newsData.source}${newsData.url}${newsData.description}`}
              className={styles['news-timelines-tabs-item-wrapper']}
            >
              <div className={styles['news-timelines-image-container']}>
                <NextgenImage
                  src={newsData.url}
                  alt={newsData.description}
                  className={styles['news-timelines-item-leftsection-image']}
                  loaderType={LoaderType.CONTENTSTACK}
                />
              </div>
              <GenericLink href={newsData?.link?.url ?? ''} target={newsData?.link?.target}>
                <div className={styles['news-timelines-item-rightsection']}>
                  <div className={styles['news-timelines-item-publishedDate']}>{newsData.publishedDate}</div>
                  <div className={styles['news-timelines-item-description']}>{newsData.description}</div>
                  <div className={styles['news-timelines-item-source']}>{newsData.source}</div>
                </div>
              </GenericLink>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NewsTimelines;

export type { NewsTimelinesProps };
